import update from 'immutability-helper';
import isNil from 'ramda/src/isNil';
import ActionTypes from 'constants/ActionTypes';

const initialState = {
    query: null,
    languageId: null,
    locationId: null,
    page: null,
    orderBy: null,
    orderDirection: null,
    domain: null,
    competitors: [],
    mode: 'domains',
    pages: null,
    excludePages: null,
};

const paramsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.PARAMS_SET: {
            const updates = {
                query: { $set: action.payload.query },
                domain: { $set: action.payload.domain },
                languageId: { $set: action.payload.languageId },
                locationId: { $set: action.payload.locationId },
                page: { $set: action.payload.page },
                orderBy: { $set: action.payload.orderBy },
                orderDirection: { $set: action.payload.orderDirection },
                competitors: { $set: action.payload.competitors },
            };
            // Per-field guard so legacy callers that don't know about mode/pages don't wipe them.
            if (action.payload.mode !== undefined) {
                updates.mode = { $set: action.payload.mode };
            }
            if (action.payload.pages !== undefined) {
                updates.pages = { $set: action.payload.pages };
            }
            if (action.payload.excludePages !== undefined) {
                updates.excludePages = { $set: action.payload.excludePages };
            }
            return update(state, updates);
        }
        case ActionTypes.PARAMS_SET_PAGE: {
            return update(state, {
                page: { $set: action.payload.page },
            });
        }
        case ActionTypes.DATA_RESULTS_RECEIVED: {
            const firstDataItem = action.payload.data[0];

            return update(state, {
                query: {
                    $set: !isNil(firstDataItem) ? firstDataItem.keyword : null,
                },
            });
        }
        default: {
            return state;
        }
    }
};

export default paramsReducer;
